import React, {useState} from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useSelector , useDispatch} from 'react-redux'
import ReactTables from "./CityAreaList";
import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
    floattest, numtest} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'

import Select from "react-select";

import { areaFetch} from "../../../actions/actions"
function CityArea(props) {
    let dispatch = useDispatch()
    const [showProcessing , setShowProcessing] = useState(false)
    const storarea  = useSelector(state => state.featureStore)
    const storarea1  = useSelector(state => state.areaStore.areaData).map((x, key) => {
    return {
          label :x.cityName.en  , value : x.cityCode, 
          labelfr : x.cityName.fr, labelar : x.cityName.ar,
          areas : x.area , key :key
        }
      })

    const [showcity, setShowcity] = useState(false)
    const [showarea, setShowarea] = useState(true)
    const [area, setArea] = useState({areaCode : "", en : "", fr : "", ar : ""})
    const [city, setCity] = useState({cityCode : "", en : "", fr : "", ar : ""})
    const [arealist, setArealist] = useState([])
    const [alert, setAlert] = React.useState(null);

    const [hidenewcityarea, setHidenewcityarea] = useState(false)

    const cinputConfirmAlert = (xcc) => {
        let mtext = ""
        if(city.cityCode === "" && area.areaCode === ""){
            //Create City with Area
            mtext ="Create City with Area"
           }else if(city.cityCode !== "" && area.areaCode === ""){
            // Create new area   
            mtext = "Create new area "
           }
           else if(city.cityCode !== "" && area.areaCode !== ""){
            // update area     
            mtext = "Update Area "
           }
           props.swal({
            title: "Are you sure?",
            text: mtext,
            icon: "warning",
            dangerMode: true,
          })
          .then(willDelete => {
            if (willDelete) {
              updateArea()
            }
          });
      };  

    const updateArea = () => {

        if(fieldvalidator(area.en, city.en )){
            props.swal("Area Name Required.")
            return
          }
        else{
            if(city.cityCode === "" && area.areaCode === ""){
                
                
                props.API.post(`tenant/createcity`, {area : area , city: city},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                  
                    window.location.reload(false)
                     props.swal(res.data.message)
                     setShowProcessing(false)
                                  
                  }).catch(function (error) {
                     setShowProcessing(false)
                        console.log("i am here")
                        if(error.response.status === 401){
                            props.swal("Unauthorized, please login again.").then(t => {
                                props.history.push(`/auth/login`)
                            })   
                        }else{
                            props.swal("Error configuring City")
                        }
                    
                  }) 
               }else if(city.cityCode !== "" && area.areaCode === ""){
                // Create new area   
                setShowProcessing(true)
                props.API.post(`tenant/createarea`, {area : area , city: city},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
           
                    window.location.reload(false)
                     props.swal(res.data.message)
                     setShowProcessing(false)
                                  
                  }).catch(function (error) {
                    setShowProcessing(false)
                      
                      props.swal("Error Updating City Area")
                  }) 
               }
               else if(city.cityCode !== "" && area.areaCode !== ""){
                setShowProcessing(true)
              
                       
                        props.API.post(`tenant/updarea`, {area : area , city: city},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                      //  dispatch(areaFetch())
                      window.location.reload(false)
                        props.swal(res.data.message)
                        setShowProcessing(false)
                                    
                    }).catch(function (error) {
                        setShowProcessing(false)
                        console.log(error)
                        props.swal("Error Updating Area")
                    }) 
        
               }
          }
     
    }  
   

    const delareacity = (cityCode, areaCode) => {
        let mtext = "Delete Area"
        props.swal({
          title: "Are you sure?",
          text: "Are you sure that you want to delete ?",
          icon: "warning",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
            props.API.post(`tenant/delareacity`, {cityCode , areaCode },{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
              props.swal(res.data.message)
               window.location.reload(false)            
              }).catch(function (error) {
                    if(error.response.status === 401){
                        props.swal("Unauthorized, please login again.").then(t => {
                            props.history.push(`/auth/login`)
                        })   
                    }else{
                        props.swal("Error Deleting Area")
                    }
                
              }) 
          }
        });
  }  

     return (
      
        <div className="content">
             {alert}
             {showProcessing && props.Spin}
        <Row>
            {/** This will contain Table */}
            <Col sm="12" md="8">
                <ReactTables areacity={storarea} delareacity={delareacity} city={city} area={area}/>
            </Col>
            <Col sm="12" md="4">
             
             <Card>
                 <CardHeader>
                  {!hidenewcityarea && <>
                    <Row>
                         <Col >
                         <FormGroup>
                               <label>Select City {city.cityCode !== "" && " Code : " +  city.cityCode}</label>
                             
                                     <Select options={storarea1} styles={customStyles} 
                                            value={{label : city.en + ' ' + city.ar, value : city.cityCode}} 
                                            onChange={e=> {
                                                    
                                                    setCity({cityCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar});
                                                    setArealist(e.areas.map((t, key) => {
                                                        return {
                                                        ...t, value : t.areaCode, label: t.en, labelfr: t.fr, labelar : t.ar, key:key
                                                        }
                                                    }));  
                                                    setArea({areaCode : "", en : "", fr : "", ar : ""})      
                                                    }}
                                            />
                               
                         </FormGroup>
                      
                         </Col>
                 </Row>
              
                 <Row>
                    <Col>
                    <FormGroup>
                         <label>Area Code</label>
                                 <Select options={arealist} styles={customStyles} 
                                   value={{label : area.en + ' '+  area.ar , value : area.cityCode}} 
                                   onChange={e=> {setArea({areaCode: e.value, en: e.label, fr: e.fr, ar: e.ar}) }}
                                   />
                         </FormGroup>
                    </Col>
                 </Row>
                  
                  </>}
                
                 {
                     showcity  && <>
                      <hr />
                 <h6>City </h6>
                 <Row>
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                              maxLength={20}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setCity({...city , en : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>{/** 
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                          maxLength={20}
                             placeholder="Nom"
                             type="text"
                             onChange = {x => {
                                setCity({...city , fr : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                            maxLength={20}
                             placeholder="اسم"
                             type="text"
                             onChange = {x => {
                                setCity({...city , ar : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                  </Row>
                  <hr />
                  <h6>Area {area.areaCode !== "" && " Code : " +  area.areaCode}</h6>
                 <Row>
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             maxLength={20}
                             value={area.en}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setArea({...area , en : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>{/**  
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                             maxLength={20}
                              value={area.fr}
                             placeholder="Nom"
                             type="text"
                             onChange = {x => {
                                setArea({...area , fr : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                             maxLength={20}
                              value={area.ar}
                             placeholder="اسم"
                             type="text"
                             onChange = {x => {
                                setArea({...area , ar : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                 </Row>
                     </>
                 }
                   {showarea && 
                <>
                 <h6>Area {area.areaCode !== "" && " Code : " +  area.areaCode}</h6>
                 <Row>
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             maxLength={20}
                             value={area.en}
                             placeholder="en"
                             type="text"
                             onChange = {x => {
                                setArea({...area , en : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>{/** 
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                             maxLength={20}
                              value={area.fr}
                             placeholder="Nom"
                             type="text"
                             onChange = {x => {
                                setArea({...area , fr : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                             maxLength={20}
                              value={area.ar}
                             placeholder="اسم"
                             type="text"
                             onChange = {x => {
                                setArea({...area , ar : x.target.value })
                             }}
                             />
                         </FormGroup>
                         </Col>
                 </Row>
                    </>
                }
                 </CardHeader>
                 <CardBody>
               
                 </CardBody>
                 <CardFooter>
                     <Button size="sm" color="primary" onClick={x => {setShowcity(!showcity); setShowarea(!showarea); setCity({cityCode : "", en : "", fr : "", ar : ""}); setArea({areaCode : "", en : "", fr : "", ar : ""}); setHidenewcityarea(!hidenewcityarea)}} >New City</Button>{' '}
                     <Button size="sm" color="primary" onClick={x => {setArea({areaCode : "", en : "", fr : "", ar : ""}); setArea({areaCode : "", en : "", fr : "", ar : ""})}} >New Area</Button>
                     <Button size="sm" color="warning" style={{float : "right"}} onClick={x => {
                        cinputConfirmAlert()
                     }}>Update</Button>
                 </CardFooter>
             </Card>
         </Col>
        </Row>
        </div>
    )
}

export default CityArea;